/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FreelanceCompanyPersonUpdateRequest
 */
export interface FreelanceCompanyPersonUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof FreelanceCompanyPersonUpdateRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof FreelanceCompanyPersonUpdateRequest
     */
    lastName: string;
    /**
     * 
     * @type {Date}
     * @memberof FreelanceCompanyPersonUpdateRequest
     */
    legalBirthdate: Date;
    /**
     * 
     * @type {string}
     * @memberof FreelanceCompanyPersonUpdateRequest
     */
    nationalityCountryCode: string;
    /**
     * 
     * @type {string}
     * @memberof FreelanceCompanyPersonUpdateRequest
     */
    birthCity: string;
    /**
     * 
     * @type {string}
     * @memberof FreelanceCompanyPersonUpdateRequest
     */
    birthCountryCode: string;
}

/**
 * Check if a given object implements the FreelanceCompanyPersonUpdateRequest interface.
 */
export function instanceOfFreelanceCompanyPersonUpdateRequest(value: object): value is FreelanceCompanyPersonUpdateRequest {
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('legalBirthdate' in value) || value['legalBirthdate'] === undefined) return false;
    if (!('nationalityCountryCode' in value) || value['nationalityCountryCode'] === undefined) return false;
    if (!('birthCity' in value) || value['birthCity'] === undefined) return false;
    if (!('birthCountryCode' in value) || value['birthCountryCode'] === undefined) return false;
    return true;
}

export function FreelanceCompanyPersonUpdateRequestFromJSON(json: any): FreelanceCompanyPersonUpdateRequest {
    return FreelanceCompanyPersonUpdateRequestFromJSONTyped(json, false);
}

export function FreelanceCompanyPersonUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelanceCompanyPersonUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'legalBirthdate': (new Date(json['legalBirthdate'])),
        'nationalityCountryCode': json['nationalityCountryCode'],
        'birthCity': json['birthCity'],
        'birthCountryCode': json['birthCountryCode'],
    };
}

export function FreelanceCompanyPersonUpdateRequestToJSON(value?: FreelanceCompanyPersonUpdateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'legalBirthdate': ((value['legalBirthdate']).toISOString().substring(0,10)),
        'nationalityCountryCode': value['nationalityCountryCode'],
        'birthCity': value['birthCity'],
        'birthCountryCode': value['birthCountryCode'],
    };
}

